import type { ICartItemError, ICartItemErrorType, Product } from "@jti/magento";

export const hasCartErrorCode = (errors: ICartItemError[], errorCode: ICartItemErrorType): boolean => {
  for (const error of errors) {
    if (error.code === errorCode) {
      return true;
    }
  }
  return false;
};

export const filterItemsByErrorCode = (items: Product[], errorCode: ICartItemErrorType): Product[] => {
  return items.filter((item) => item.errors?.some((error) => error.code === errorCode));
};
